import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import $image_url from 'js/utils/image_url';
import { PremiumIcon } from 'javascripts/analytics/components/premium_icon';
import { trackAnalyticsClick } from 'js/analytics/metrics/analyticsTracking';

export const KeywordsHitsTableRow = createReactClass({
  propTypes: {
    hit: PropTypes.object.isRequired,
    showKeywords: PropTypes.bool.isRequired,
    isShareable: PropTypes.bool,
    showSearchEngine: PropTypes.bool,
    showPremiumIcon: PropTypes.bool,
    popoverOptions: PropTypes.object.isRequired,
    highlighted: PropTypes.bool,
  },

  popoverOptions: {
    popoverText:
      'Your paper appeared in an Academia.edu search result with this term.',
    popoverLink: $r.upgrade_url({
      feature: 'keywords',
      trigger: 'internal-keywords',
    }),
    popoverContainer: 'body',
  },

  keywordPopoverImpression: {
    source: 'analytics-upgrade-door',
    key: 'keywords_popover',
    extra: {
      door: 'keywords_popover',
      trigger: 'internal-keywords',
    },
  },

  trackKeywordUpgradeClick: function () {
    trackAnalyticsClick('analytics-upgrade-door', {
      door: 'keywords_popover',
      trigger: 'internal-keywords',
    });
  },

  getInitialState: function () {
    return {
      finishedScrolling: false,
    };
  },

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line react/display-name
  renderTweetButton: function (hit) {
    return (
      <div className="col-xs-1 u-p0x">
        <img
          className="u-clickable"
          src={$image_url('share_icons_twitter.png')}
          onClick={() => {
            trackAnalyticsClick('analytics-keyword-share', {
              network: 'twitter',
            });
            this.openTwitterShareWindowForKeywordHit(hit);
          }}
        />
      </div>
    );
  },

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line react/display-name
  renderSearchEngine: function (hit) {
    return (
      <td className="premium-hits-table-td">
        <a
          href={hit.referer.url}
          onClick={() =>
            trackAnalyticsClick('analytics-content-link', {
              link_type: 'search_engine',
              table: 'keywords',
            })
          }
        >
          {hit.referingSearchEngine}
        </a>
      </td>
    );
  },

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line react/display-name
  renderKeyword: function (hit) {
    if (!this.props.showKeywords) {
      return (
        <div className="col-xs-10 premium-hits-table-restricted-data">
          <span className="u-pv2x PremiumIconContainerHoverWrapper js-PremiumIconContainerHoverWrapper">
            {hit.referer.query}
            <PremiumIcon
              style={{ top: '-1px', visibility: 'hidden' }}
              className="u-positionRelative"
              popoverBodyText={this.props.popoverOptions.popoverText}
              popoverLinkUrl={this.props.popoverOptions.popoverLink}
              popoverContainer={this.props.popoverOptions.popoverContainer}
              disableHoverBehavior={this.props.showKeywords}
              onPopoverLinkClick={this.trackKeywordUpgradeClick}
              popoverImpression={this.keywordPopoverImpression}
            />
          </span>
        </div>
      );
    }
    return <div className="col-xs-10">{hit.referer.query}</div>;
  },

  openTwitterShareWindowForKeywordHit: function (hit) {
    const text =
      'Someone found my @academia page on ' +
      hit.referingSearchEngine +
      ' by searching for "' +
      hit.referer.query +
      '"';
    const shareUrl = hit.page.url;
    window.Academia.openTwitterShareWindow(text, shareUrl);
  },

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line react/display-name
  render: function () {
    const hit = this.props.hit;
    const colSpan = this.props.showSearchEngine ? '1' : '2';
    let backgroundClass = '';
    if (this.props.highlighted) {
      if (this.state.finishedScrolling) {
        backgroundClass = 'u-bgColorGrayLighter';
      } else {
        backgroundClass = 'u-bgColorGray';
      }
    }
    return (
      <tr
        id={'keyword-row-' + hit.id.toString()}
        ref={this.highlightTargetRow}
        key={hit.id}
        className={backgroundClass}
        style={{ transition: 'background-color 1s ease' }}
      >
        <td className="premium-hits-table-td">{hit.referer.time}</td>
        <td className="u-fontMonospaced u-fs12 u-taCenter">
          {' '}
          {hit.referer.rank || '—'}{' '}
        </td>
        <td className="premium-hits-table-td" colSpan={colSpan}>
          <a
            href={hit.page.url}
            onClick={() =>
              trackAnalyticsClick(
                'analytics-content-link',
                { link_type: 'target', table: 'keywords' },
                Number.isInteger(hit.page.work_id)
                  ? hit.page.work_id
                  : undefined,
              )
            }
          >
            {hit.page.title || hit.page.category}
          </a>
        </td>
        {this.props.showSearchEngine && this.renderSearchEngine(hit)}
        <td className="container-fluid">
          <div className="row">
            {this.renderKeyword(hit)}
            {this.props.isShareable && this.renderTweetButton(hit)}
          </div>
        </td>
      </tr>
    );
  },

  highlightTargetRow: function (targetRow) {
    if (
      this.state.finishedScrolling ||
      !this.props.highlighted ||
      targetRow === null
    ) {
      return;
    }

    $('html, body').animate(
      { scrollTop: $(targetRow).offset().top },
      1000,
      function () {
        this.setState({ finishedScrolling: true });
      }.bind(this),
    );
  },
});
